$.extend tower,
  changeReportDate: ->
    isWeek = $(@).data('week')
    url = simple.url()
    date = moment url.search.date

    date.startOf('isoWeek') if isWeek

    popover = simple.popover
      pointTo: $(@)
      content: """<input type="date" value="#{date.format('YYYY-MM-DD')}">"""
      position: "bottom-center"

    momentpicker = simple.momentpicker
      el: popover.el.find('input')
      inline: true
      cls: 'no-border reports-question-picker'

    momentpicker.setMoment(date)
    momentpicker.on 'select', (e, params)->
      date = params.moment
      date = date.startOf('isoWeek') if isWeek
      url.search.date = date.format('YYYY-MM-DD')
      tower.stack.load url,
        nocache: true
        replace: true

    popover.refresh()
